import script from "./ProjectChatList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectChatList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer});
